export default __webpack_public_path__ + "static/media/greenCircle.a9445f1d.svg";